import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useContext, useEffect, useMemo, useState } from "react";
import debounce from "lodash.debounce";
import useSWR from "swr";
import { AppExperimentContext, emitSearchAction, emitSearchboxImpression, SOURCE_TYPE_ENHANCED_SEARCH_BOX } from "@catchoftheday/analytics";
import { Box, Highlighter, Span } from "@catchoftheday/cg-components";
import { css, styled, themeGet } from "@catchoftheday/theme";
import { encodeSearchTerm, localStorage } from "@catchoftheday/utilities";
import { fetcher } from "../../api/index";
import { HeaderContext } from "../../context";
import { useSearchRedirectsLazyQuery } from "../../generated/graphql";
import { getQueryStringValue, isTickerVisible, searchRedirectUrl } from "../../utilities/index";
import { EnhancedSearchBar } from "../EnhancedSearchBar";
import { updateRecentSearches } from "../EnhancedSearchBar/utilities/updateRecentSearches";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ENHANCED_SEARCHBOX_DEBOUNCE_TIME = 480;
var SEARCH_REDIRECTS_KEY = "search-redirects";
var SEARCH_REDIRECTS_EXPIRY = 5 * 60; // 5 minutes

var EnhancedSearchItemContainer = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n    cursor: pointer;\n  }\n"])), function (props) {
  return props.isHighlighted ? css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          color: ", ";\n          text-decoration: underline;\n        "])), themeGet("colors.typography.link")(props)) : "background-color: transparent; color: ".concat(themeGet("colors.typography.textSecondary")(props), ";");
}, themeGet("colors.typography.link"));

function transformSearchData(searchData) {
  var result = searchData.reduce(function (acc, curr) {
    var value = curr.value,
        categories = curr.categories;
    var filteredCategories = categories ? categories.filter(function (cat) {
      return cat;
    }) : [];
    var searchTermOnlySuggestion = [{
      title: value
    }];
    var suggestions = filteredCategories.length > 0 ? searchTermOnlySuggestion.concat(filteredCategories.map(function (cat) {
      return {
        title: value,
        value: cat
      };
    })) : searchTermOnlySuggestion;
    return acc.concat(suggestions);
  }, []);
  return result;
}

export var SearchBar = function SearchBar(props) {
  var headerContext = useContext(HeaderContext);

  var _useState = useState(""),
      searchTerm = _useState[0],
      setSearchTerm = _useState[1];

  var _useState2 = useState(""),
      inputTerm = _useState2[0],
      setInputTerm = _useState2[1];

  var _useState3 = useState(false),
      showSearchData = _useState3[0],
      setShowSearchData = _useState3[1];

  var _useState4 = useState(false),
      isUserTyping = _useState4[0],
      setIsUserTyping = _useState4[1];

  var _useState5 = useState([]),
      searchRedirects = _useState5[0],
      setSearchRedirects = _useState5[1];

  var _useContext = useContext(AppExperimentContext),
      getExperiments = _useContext.getExperiments;

  var _getExperiments = getExperiments(["search_category_filters_apr23"]),
      _getExperiments$exper = _slicedToArray(_getExperiments.experiments, 1),
      categoryExperiment = _getExperiments$exper[0];

  var debouncedSetSearchTerm = useMemo(function () {
    return debounce(function (value) {
      setSearchTerm(value);
      setTimeout(function () {
        // Timeout prevents flicker before the isValidating state kicks in
        setIsUserTyping(false);
      }, 20);
    }, ENHANCED_SEARCHBOX_DEBOUNCE_TIME);
  }, [setSearchTerm]);

  var _useSWR = useSWR(function () {
    return searchTerm ? "/autocomplete/2?query=".concat(encodeSearchTerm(searchTerm)) : null;
  }, fetcher, {
    dedupingInterval: 0,
    revalidateOnFocus: false
  }),
      data = _useSWR.data,
      isValidating = _useSWR.isValidating;

  console.log("data", data);

  var _useSearchRedirectsLa = useSearchRedirectsLazyQuery(),
      _useSearchRedirectsLa2 = _slicedToArray(_useSearchRedirectsLa, 1),
      getRedirects = _useSearchRedirectsLa2[0];

  useEffect(function () {
    var searchRedirects = localStorage.getItemWithExpiry(SEARCH_REDIRECTS_KEY);

    if (searchRedirects) {
      setSearchRedirects(JSON.parse(searchRedirects));
    }
  }, []);

  var renderEnhancedSearchItem = function renderEnhancedSearchItem(_ref) {
    var _itemData$value;

    var itemData = _ref.itemData,
        isHighlighted = _ref.isHighlighted;
    return ___EmotionJSX(EnhancedSearchItemContainer, {
      isHighlighted: isHighlighted,
      fontWeight: "light"
    }, ___EmotionJSX(Highlighter, {
      highlight: inputTerm,
      text: itemData.title,
      reverse: inputTerm !== searchTerm,
      highlightTextProps: {
        fontSize: "14px"
      },
      textProps: {
        fontSize: "14px"
      }
    }), ___EmotionJSX(Span, {
      color: "secondary",
      fontSize: "sm"
    }, itemData.value ? " in ".concat((_itemData$value = itemData.value) === null || _itemData$value === void 0 ? void 0 : _itemData$value.name) : ""));
  };

  var onInputChange = function onInputChange(value, reason) {
    if (reason.onChange) {
      setIsUserTyping(true);
      debouncedSetSearchTerm.cancel(); // Only search if input term is different from current search term

      debouncedSetSearchTerm(value); // Update input term state to match with user input

      setInputTerm(value); // CLear suggestions if input term is different from current search term

      if (value.trim() != searchTerm.trim()) {
        setShowSearchData(false);
      }
    }
  };

  var searchData = (data === null || data === void 0 ? void 0 : data.data) || [];
  var suggestions = searchData && searchData.length > 0 ? transformSearchData(searchData) : [];
  var categoryFacet = categoryExperiment !== null && categoryExperiment !== void 0 && categoryExperiment.bucket ? "category_correlated" : "category";

  function getRedirectUrl(_x) {
    return _getRedirectUrl.apply(this, arguments);
  }

  function _getRedirectUrl() {
    _getRedirectUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(term) {
      var _data$searchRedirects, _yield$getRedirects, _data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(searchRedirects.length === 0)) {
                _context.next = 10;
                break;
              }

              _context.next = 3;
              return getRedirects();

            case 3:
              _yield$getRedirects = _context.sent;
              _data = _yield$getRedirects.data;

              if (!(_data !== null && _data !== void 0 && (_data$searchRedirects = _data.searchRedirects) !== null && _data$searchRedirects !== void 0 && _data$searchRedirects.redirects)) {
                _context.next = 9;
                break;
              }

              setSearchRedirects(_data.searchRedirects.redirects);
              localStorage.setItemWithExpiry(SEARCH_REDIRECTS_KEY, JSON.stringify(_data.searchRedirects.redirects), SEARCH_REDIRECTS_EXPIRY);
              return _context.abrupt("return", searchRedirectUrl(term, _data.searchRedirects.redirects));

            case 9:
              return _context.abrupt("return", null);

            case 10:
              return _context.abrupt("return", searchRedirectUrl(term, searchRedirects));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _getRedirectUrl.apply(this, arguments);
  }

  function navigateToSearchPage(_x2, _x3, _x4, _x5) {
    return _navigateToSearchPage.apply(this, arguments);
  }

  function _navigateToSearchPage() {
    _navigateToSearchPage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(term, category, itemData, sourceType) {
      var encodedSearchTerm, query, params, url, redirectUrl, isSpecialSearch, specialSearchDetails;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!term || term.length == 1)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              encodedSearchTerm = encodeSearchTerm(term);
              query = "/search?query=".concat(encodedSearchTerm);
              params = "&search_src=topbar&ac=0".concat(category ? "&f[".concat(categoryFacet, "]=").concat(category.id, "&acs=1") : "").concat(sourceType ? "&st=".concat(sourceType) : "");
              url = "".concat(query).concat(encodeURI(params));
              _context2.next = 8;
              return getRedirectUrl(term);

            case 8:
              redirectUrl = _context2.sent;
              isSpecialSearch = !!(redirectUrl || category);
              specialSearchDetails = isSpecialSearch ? {
                type: redirectUrl ? "redirect" : "search_in_category",
                category: category === null || category === void 0 ? void 0 : category.name,
                redirect_path: redirectUrl || undefined
              } : undefined;
              emitSearchAction({
                user_text: inputTerm,
                is_typehead: !!(itemData && itemData.title !== inputTerm),
                final_text: term,
                is_special_search: isSpecialSearch,
                special_search_details: specialSearchDetails
              });

              if (!redirectUrl) {
                _context2.next = 14;
                break;
              }

              return _context2.abrupt("return", location.assign(redirectUrl));

            case 14:
              window.location.assign(url);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _navigateToSearchPage.apply(this, arguments);
  }

  var urlSearchQuery = getQueryStringValue("query");
  useEffect(function () {
    if (urlSearchQuery) {
      setInputTerm(urlSearchQuery);
      setSearchTerm(urlSearchQuery);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  useEffect(function () {
    if (searchTerm) {
      setShowSearchData(true);
    }
  }, [searchTerm]);
  return ___EmotionJSX(EnhancedSearchBar, _extends({
    isLoading: !!searchTerm && isValidating,
    onInputChange: onInputChange,
    defaultValue: urlSearchQuery,
    searchTerm: searchTerm,
    onItemSelected: function onItemSelected(itemData) {
      var term = (itemData === null || itemData === void 0 ? void 0 : itemData.title) || inputTerm;
      var category = itemData === null || itemData === void 0 ? void 0 : itemData.value;
      var categoryKey = "f[".concat(categoryFacet, "]");

      if (headerContext.onSearchChange) {
        var _headerContext$onSear;

        headerContext.onSearchChange((_headerContext$onSear = {
          query: term
        }, _defineProperty(_headerContext$onSear, categoryKey, category ? category.id : undefined), _defineProperty(_headerContext$onSear, "acs", "1"), _headerContext$onSear));
      } else {
        navigateToSearchPage(term, category, itemData, SOURCE_TYPE_ENHANCED_SEARCH_BOX);
      }

      updateRecentSearches(term);
    },
    onSearchButtonClicked: function onSearchButtonClicked() {
      if (headerContext.onSearchChange) {
        headerContext.onSearchChange({
          query: inputTerm
        });
      } else {
        navigateToSearchPage(inputTerm, null);
      }

      updateRecentSearches(inputTerm);
    },
    onInputFocus: emitSearchboxImpression,
    data: showSearchData ? suggestions : [],
    renderListItem: renderEnhancedSearchItem,
    isTickerEnabled: isTickerVisible(),
    inputProps: {
      px: {
        sm: "10px",
        md: "20px"
      }
    },
    isSearchTermLoading: isUserTyping || isValidating
  }, props));
};
export default SearchBar;